var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalChangeData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8123 7.3501C15.4849 7.612 14.9999 7.3789 14.9999 6.9597V4.99999H2.9999C2.44762 4.99999 1.9999 4.55228 1.9999 3.99999C1.9999 3.44771 2.44762 2.99999 2.9999 2.99999H14.9999V1.04031C14.9999 0.62105 15.4849 0.38797 15.8123 0.64987L19.5119 3.60956C19.7621 3.80972 19.7621 4.19027 19.5119 4.39043L15.8123 7.3501ZM4.18756 15.3501C4.51494 15.612 4.9999 15.3789 4.9999 14.9597V13H16.9999C17.5522 13 17.9999 12.5523 17.9999 12C17.9999 11.4477 17.5522 11 16.9999 11H4.9999V9.0403C4.9999 8.6211 4.51494 8.388 4.18756 8.6499L0.48795 11.6096C0.23774 11.8097 0.23774 12.1903 0.48795 12.3904L4.18756 15.3501Z",
    fill: "#7B67FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalChangeData);
export default __webpack_public_path__ + "static/media/modalChangeData.cf22a177a974c28b845c9e087107bf2f.svg";
export { ForwardRef as ReactComponent };